import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import queryString from 'query-string'
import { listPartner } from '../../services/api/3dApi'

const { Option } = Select

class FilterSkuPartner extends Component {
    state = {
        partners: [],
        error: '',
    }

    componentDidMount() {
        this._fetchPartners()
    }

    _fetchPartners = async () => {
        try {
            const query = queryString.stringify({type: 'sewing_partner', hidden: false, limit: 1000})
            const { data: response } = await listPartner(query)
            const { success, error, data } = response

            if (!success) {
                return this.setState({ error })
            }

            this.setState({ partners: data.partners || [] })
        } catch (e) {
            this.setState({ error: e.message })
        }
    }

    render() {
        const { partners } = this.state
        const { value, onChange, disabled } = this.props

        return (
            <div className='col-12 col-xl-2 mb-3'>
                <label className="font-weight-bold d-block">SKU theo đối tác</label>
                <Select
                    mode='multiple'
                    allowClear
                    showArrow
                    showSearch
                    placeholder='Chọn đối tác may'
                    style={{ width: '100%' }}
                    value={value}
                    onChange={onChange}
                    disabled={disabled}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    dropdownClassName='custom-select-partner'
                >
                    {partners.map(item => (
                        <Option key={item._id} value={item._id}>{item.name}</Option>
                    ))}
                </Select>
            </div>
        )
    }
}

FilterSkuPartner.propTypes = {
    value: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default FilterSkuPartner
